/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';

import { DialogRef } from '@ngneat/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import flatpickr from 'flatpickr';
import { Instance } from 'flatpickr/dist/types/instance';
import moment from 'moment-timezone';
import { Product, Reservation } from 'rest-client';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { RemoveUserMessageAction } from '@app/modules/core/states/auth-state/auth.actions';
import { SetBookingDatesAction } from '@app/modules/core/states/booking-state/booking.actions';
import {
  BookingData,
  BookingDates,
} from '@app/modules/core/states/booking-state/booking.model';
import { BookingState } from '@app/modules/core/states/booking-state/booking.state';
import { SetOfferAction } from '@app/modules/core/states/offer-state/offer.actions';
import { OfferStateModel } from '@app/modules/core/states/offer-state/offer.model';
import { OfferState } from '@app/modules/core/states/offer-state/offer.state';
import {
  SetCommonTerminalsAction,
  SetFlightNumberAction,
  SetPassengersAction,
  SetTerminalsAction,
} from '@app/modules/core/states/trip-state/trip.actions';
import { TripStateModel } from '@app/modules/core/states/trip-state/trip.model';
import { TripState } from '@app/modules/core/states/trip-state/trip.state';
import {
  DATE_FORMAT,
  DATE_PICKER_DEFAULT_CONFIG,
  DATE_TIME_FORMAT,
  getEndDateFromStartDateInput,
} from '@shared/const/date-picker.consts';
import {
  START_HOUR_PICKER_ID,
  END_HOUR_PICKER_ID,
  getHourPickerPosition,
  formatPreselectedDateWithHour,
} from '@shared/const/hour-picker.const';

import { HourSelected } from '../../models/hour-selected.model';
import { Passengers } from '../../models/passengers.model';
import { getCommonTerminal } from '../../utils/reservation.utils';
import { ReservationState } from '@app/modules/core/states/reservation-state/reservation.state';
import { ReservationStateModel } from '@app/modules/core/states/reservation-state/reservation.model';
import { PRODUCTS } from '../../const/products.const';
import { PRODUCT_TYPES } from '@app/modules/steps/products-step/utils/product.const';


@UntilDestroy()
@Component({
  selector: 'bkg-date-dialog',
  templateUrl: './date-dialog.component.html',
  styleUrls: ['./date-dialog.component.scss'],
})
export class DateDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('startDatePicker') startDatePicker: ElementRef;
  @ViewChild('endDatePicker') endDatePicker: ElementRef;
  @Select(OfferState.offerData)
  offerData$: Observable<OfferStateModel>;
  @Select(BookingState.bookingDates)
  bookingDates$: Observable<BookingDates>;
  @Select(BookingState.bookingData)
  bookingData$: Observable<BookingData>;
  @Select(TripState.trip) tripData$: Observable<TripStateModel>;
  @Select(ReservationState.reservationData)
  reservationData$: Observable<ReservationStateModel>;

  form: FormGroup;
  startHourPickerId = START_HOUR_PICKER_ID;
  endHourPickerId = END_HOUR_PICKER_ID;
  isStartHourPicker = false;
  isEndHourPicker = false;
  prevSelectedStartHours: HourSelected;
  prevSelectedEndHours: HourSelected;
  selectedStartHours: HourSelected;
  selectedEndHours: HourSelected;
  currentStart: string;
  currentEnd: string;
  selectedStart: Date;
  errorShow: any;
  errorMessage: string;
  tripData: TripStateModel;
  notReturnFlight = false;
  flightNumber: string;
  passengers: Passengers;
  notPassengers = false;
  bookingData: any;
  customHoursStart: Array<string>;
  customHoursEnd: Array<string>;
  customRange: any;
  placeProduct: Product;
  terminals: any;
  changedTerminals = false;
  reservationData: Reservation;
  products = PRODUCTS;

  private endDatePickerInstance: Instance;
  // TODO: its needed when adapt language
  private startDatePickerInstance: Instance;

  constructor(
    public ref: DialogRef,
    private fb: FormBuilder,
    private store: Store
  ) { }

  get isButtonDisabled(): boolean {
    if (this.hasFlightNumber) {
      return this.notReturnFlight || this.form?.invalid;
    } else if (this.hasPassengers) {
      return this.notPassengers || this.form?.invalid;
    }
    return this.form?.invalid;
  }

  get hasPassengers(): boolean {
    return this.productPassengerVisibility && !!this.tripData.in_passengers && !!this.tripData.out_passengers;
  }

  get productPassengerVisibility(): boolean {
    return (
      this.bookingData?.product?.service === PRODUCT_TYPES.express ||
      this.bookingData?.product?.service === PRODUCT_TYPES.port ||
      this.reservationData?.product?.service === PRODUCT_TYPES.express ||
      this.reservationData?.product?.service === PRODUCT_TYPES.port
    );
  }

  get hasFlightNumber(): boolean {
    return !!this.tripData.flight_number;
  }

  get hasTerminals(): boolean {
    return !!this.tripData.in_terminal;
  }

  ngOnInit(): void {
    this.errorShow = this.ref?.data?.errorShow;
    if (this.errorShow) {
      this.errorMessage = this.errorShow?.error?.reason;
    }
    this.setInitHours();
    this.subscribeToReservationData()
    this.subscribeToBookingData();
    this.subscribeToTripData();
    this.subscribeToDates();
  }


  private subscribeToReservationData(): void {
    this.reservationData$
      .pipe(untilDestroyed(this))
      .subscribe((reservationData: ReservationStateModel) => {
        this.reservationData = reservationData;
      });
  }

  ngAfterViewInit(): void {
    this.initPickers();
  }

  setInitHours(): void {
    const coeff = 1000 * 60 * 15;
    const date = new Date();
    const rounded = new Date(Math.ceil(date.getTime() / coeff) * coeff);
    this.prevSelectedStartHours = {
      hours: rounded.getHours(),
      minutes: rounded.getMinutes(),
    };
    this.prevSelectedEndHours = {
      hours: rounded.getHours(),
      minutes: rounded.getMinutes(),
    };
    this.selectedEndHours = this.prevSelectedEndHours;
    this.selectedStartHours = this.prevSelectedStartHours;
  }

  onClickBooking(): void {
    const startDate = moment(
      this.getControlValue('startDate'),
      DATE_TIME_FORMAT
    ).format();

    const endDate = moment(
      this.getControlValue('endDate'),
      DATE_TIME_FORMAT
    ).format();

    this.offerData$
      .pipe(untilDestroyed(this), first())
      .subscribe((offerData: OfferStateModel) => {
        this.store.dispatch(new RemoveUserMessageAction());

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const offer = JSON.parse(JSON.stringify(offerData.offer));

        this.store.dispatch(new SetBookingDatesAction(startDate, endDate));
        if (this.hasFlightNumber) {
          this.store.dispatch(new SetFlightNumberAction(this.flightNumber));
        }
        if (this.hasPassengers) {
          this.store.dispatch(
            new SetPassengersAction(
              this.passengers.inPassengers,
              this.passengers.outPassenger
            )
          );
        }
        if (offer) {
          offer.startDate = moment(startDate).toDate();
          offer.endDate = moment(endDate).toDate();
          if (this.changedTerminals) {
            offer.in_terminal = this.terminals?.in_terminal ?? null;
            offer.out_terminal = this.terminals?.out_terminal ?? null;
            this.store.dispatch(new SetCommonTerminalsAction(getCommonTerminal(offer.in_terminal), getCommonTerminal(offer.out_terminal)));
            this.store.dispatch(new SetTerminalsAction(offer.in_terminal, offer.out_terminal));
          }
          this.store.dispatch(new SetOfferAction(offer));
          this.ref.close(true);
        } else {
          this.ref.close(false);
        }
      });
  }

  onCloseBanner(): void {
    this.errorMessage = null;
  }

  onClickClose(): void {
    this.ref.close(false);
  }

  onFlightNumber(flightNumber: string): void {
    this.flightNumber = flightNumber;
    this.notReturnFlight = this.flightNumber ? false : true;
  }

  onChangePassengers(passengers: Passengers): void {
    this.passengers = passengers;
    this.notPassengers =
      passengers?.inPassengers > 0 && passengers.outPassenger > 0
        ? false
        : true;
  }

  onChangeTerminals(terminals: any): void {
    this.changedTerminals = true;
    this.terminals = terminals;
  }

  hasErrors(fieldName: string): boolean {
    const control = this.getControl(fieldName);
    return !!control?.invalid && !!control?.touched;
  }

  initPickers(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const ctx = this;
    this.endDatePickerInstance = flatpickr(this.endDatePicker.nativeElement, {
      ...DATE_PICKER_DEFAULT_CONFIG,
      positionElement: document.getElementById('centerScreen'),
      onDayCreate: function (
        dObj: Date[],
        dStr: string,
        fp: Instance,
        dayElem: any
      ) {
        //console.log('recorriendo dias:', dObj, dStr, fp, dayElem);
        // utilize fp.currentYear, fp.currentMonth, dayElem.textContent
        const selected = moment(ctx.selectedStart).format(DATE_FORMAT);
        const compareDate = moment(dayElem.dateObj).format(DATE_FORMAT);
        if (selected === compareDate) {
          dayElem.className += ' flatpickr-start-date';
        }
      },
    });

    this.startDatePickerInstance = flatpickr(
      this.startDatePicker.nativeElement,
      {
        ...DATE_PICKER_DEFAULT_CONFIG,
        positionElement: document.getElementById('centerScreen'),
      }
    );
  }

  private subscribeToTripData(): void {
    this.tripData$
      .pipe(untilDestroyed(this))
      .subscribe((tripData: TripStateModel) => {
        this.tripData = tripData;
        if (this.hasPassengers) {
          this.passengers = {
            inPassengers: this.tripData.in_passengers,
            outPassenger: this.tripData.out_passengers,
          };
        } else if (this.hasFlightNumber) {
          this.flightNumber = this.tripData.flight_number;
        }
        if (!this.terminals) {
          this.terminals = {
            in_terminal: this.tripData.in_terminal,
            out_terminal: this.tripData.out_terminal
          };
        }
      });
  }

  private subscribeToBookingData(): void {
    this.bookingData$
      .pipe(untilDestroyed(this))
      .subscribe((bookingData: any) => {
        this.bookingData = bookingData;
        let placeProduct = this.bookingData?.place?.products?.filter(
          (product: any) => product?.id === this.bookingData?.product?.id
        )[0];
        if (!placeProduct && this.bookingData?.place?.products?.length === 1) {
          placeProduct = this.bookingData?.place?.products[0];
        }
        this.placeProduct = placeProduct;
        if (placeProduct?.openingHours?.type == 3) {
          this.customHoursStart = placeProduct.specific_checkin_hours?.split(
            ','
          );
          this.customHoursEnd = placeProduct.specific_checkout_hours?.split(
            ','
          );
        } else if (placeProduct?.openingHours?.type == 2) {
          this.customRange = {
            open: placeProduct?.openingHours?.open,
            close: placeProduct?.openingHours?.close,
          };
        }
      });
  }

  private subscribeToDates(): void {
    this.bookingDates$
      .pipe(untilDestroyed(this))
      .subscribe((bookingDates: BookingDates) => {
        this.currentStart = bookingDates.startDate;
        this.currentEnd = bookingDates.endDate;
        this.initForm();
        this.subscribeToStartDate();
        this.subscribeToEndDate();
      });
  }

  private initForm(): void {
    this.selectedStart = new Date(this.currentStart);
    this.form = this.fb.group({
      startDate: [this.getStartDate(), Validators.required],
      endDate: [this.getEndDate(), Validators.required],
    });
  }

  private getStartDate(): string {
    return moment(this.currentStart).format(DATE_TIME_FORMAT);
  }

  private getEndDate(): string {
    return moment(this.currentEnd).format(DATE_TIME_FORMAT);
  }

  private subscribeToStartDate(): void {
    const startDateControl = this.getControl('startDate');
    const endDateControl = this.getControl('endDate');

    startDateControl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((value: string) => {
        if (this.prevSelectedStartHours && !this.isStartHourPicker) {
          this.onChangeDatePreserveStartPreselectedHours();
          return;
        }

        if (!this.isStartHourPicker) {
          this.isStartHourPicker = true;
        } else {
          const preSelectedDateOut = getEndDateFromStartDateInput(value);
          const date = moment(value, DATE_TIME_FORMAT);
          const parsedSelectedStart = date.toDate();
          parsedSelectedStart.setHours(this.selectedStartHours.hours);
          parsedSelectedStart.setMinutes(this.selectedStartHours.minutes);
          this.selectedStart = parsedSelectedStart;
          this.endDatePickerInstance.set({
            minDate: value,
            defaultDate: preSelectedDateOut,
          });
          this.endDatePickerInstance.setDate(preSelectedDateOut);
          endDateControl.setValue(preSelectedDateOut);
          endDateControl.updateValueAndValidity();
          endDateControl.markAllAsTouched();
        }
      });
  }

  private onChangeDatePreserveStartPreselectedHours(): void {
    const selectedHourData: HourSelected = Object.assign(
      {},
      this.prevSelectedStartHours
    );
    this.prevSelectedStartHours = null;
    this.setSelectedHours('startDate', selectedHourData);
  }

  private subscribeToEndDate(): void {
    const endDateControl = this.getControl('endDate');

    endDateControl.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      if (this.isStartHourPicker) return;

      if (this.prevSelectedEndHours && !this.isEndHourPicker) {
        this.onChangeDatePreserveEndPreselectedHours();
        return;
      }

      if (!this.isEndHourPicker) this.isEndHourPicker = true;
    });
  }

  private onChangeDatePreserveEndPreselectedHours(): void {
    const selectedHourData: HourSelected = Object.assign(
      {},
      this.prevSelectedEndHours
    );
    this.prevSelectedEndHours = null;
    this.setSelectedHours('endDate', selectedHourData);
  }

  get startHourPickerPosition(): string {
    return getHourPickerPosition(0);
  }

  get endHourPickerPosition(): string {
    return getHourPickerPosition(1);
  }

  private getControl(controlName: string): AbstractControl {
    return this.form.get(controlName);
  }

  private getControlValue(controlName: string): unknown {
    return this.getControl(controlName).value as unknown;
  }

  onSelectedStartHour(selectedHour: HourSelected): void {
    this.prevSelectedStartHours = selectedHour;
    this.prevSelectedEndHours = selectedHour;
    this.selectedStartHours = selectedHour;
    this.selectedEndHours = selectedHour;
    this.setSelectedHours('startDate', selectedHour);
    this.isStartHourPicker = false;
    this.endDatePicker.nativeElement.focus();
  }

  onSelectedEndHour(selectedHour: HourSelected): void {
    this.prevSelectedEndHours = selectedHour;
    this.selectedEndHours = selectedHour;
    this.setSelectedHours('endDate', selectedHour);
    this.isEndHourPicker = false;
  }

  private setSelectedHours(
    controlName: string,
    selectedHours: HourSelected
  ): void {
    const control = this.getControl(controlName);
    const preseletedDate = this.getControlValue(controlName) as string;

    const dateWithHour = formatPreselectedDateWithHour(
      preseletedDate,
      selectedHours
    );

    control.setValue(dateWithHour);
  }

  onOutClickHourPickerStart(value: boolean): void {
    if (
      this.selectedStart &&
      this.selectedStartHours &&
      !this.prevSelectedStartHours
    ) {
      this.onSelectedStartHour(this.selectedStartHours);
    }
    this.isStartHourPicker = !value;
  }

  onOutClickHourPickerEnd(value: boolean): void {
    this.isEndHourPicker = !value;
  }

  get showStartHourPicker(): boolean {
    return this.isStartHourPicker;
  }

  get showEndHourPicker(): boolean {
    return this.isEndHourPicker;
  }
}
